{
  "titles": {
    "details": "Bedrijfsgegevens",
    "companyInformation": "Bedrijfsinformatie",
    "invoiceInformation": "Facturatiegegevens",
    "documents": "Documenten",
    "advisors": "Adviseurs"
  },
  "fields": {
    "labels": {
      "name": "Bedrijfsnaam",
      "registrationNumber": "KvK-nummer",
      "registeredOffice": "Statutaire zetel",
      "address": "Adres",
      "phone": "Algemeen telefoonnummer",
      "partnerSince": "Partner sinds",
      "legalStructure": "Rechtsvorm",
      "signingAuthorities": "Ondertekenaars",
      "iban": "IBAN",
      "bic": "BIC"
    }
  },
  "invoiceInformation": {
    "fields": {
      "labels": {
        "name": "Facturatie gericht aan",
        "email": "E-mailadres"
      }
    }
  }
}
